<script lang="ts">
	//Design system components
	import { TemperatureWheel, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from '../../../../helpers/utilities';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';

	const scheduleStore: SvelteStore<any> = getContext('schedule');

	let temperature = $scheduleStore.colorTemperature;
	let min = $scheduleStore.min;
	let max = $scheduleStore.max;
	let valuePrefix = $scheduleStore.valuePrefix;
	const dispatch = createEventDispatcher();
	const changeTemperature = (e) => {
		temperature = e.detail.value;
		dispatch('update', { colorTemperature: temperature });
	};

	//ToDo need to be tested

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', { default: 'Temperature' }),
		thumbAriaLabel: $format('label_temperature_thumb', { default: 'Temperature thumb' }),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
	};
</script>

<Text class="mb-l" element="h2">
	{capFirstChar($format('label_white_balance'))}
</Text>
<TemperatureWheel
	{a11yProps}
	value={temperature}
	{min}
	{max}
	{valuePrefix}
	on:value_change={changeTemperature}
/>
